import type { MomentStatus } from "../moment-card/types";

/**
 * Whether the Communication has gone out.
 */
export const isPublishedMomentStatus = (status: MomentStatus): boolean =>
  status === "active" || status === "finished";
